import { createContext, useContext } from 'react';
export const ReadonlyNetworksContext = createContext({
    providers: {},
    updateNetworkState: () => undefined,
});
export function useReadonlyNetworks() {
    return useContext(ReadonlyNetworksContext).providers;
}
export function useUpdateNetworksState() {
    return useContext(ReadonlyNetworksContext).updateNetworkState;
}
//# sourceMappingURL=context.js.map